/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SendTimeRegEmailInput = {|
  receiverId?: ?string,
  receiverIds?: ?$ReadOnlyArray<?string>,
  dateRange?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type sendTimeRegEmailMutationVariables = {|
  input: SendTimeRegEmailInput
|};
export type sendTimeRegEmailMutationResponse = {|
  +sendTimeRegEmail: ?{|
    +clientMutationId: ?string
  |}
|};
export type sendTimeRegEmailMutation = {|
  variables: sendTimeRegEmailMutationVariables,
  response: sendTimeRegEmailMutationResponse,
|};
*/


/*
mutation sendTimeRegEmailMutation(
  $input: SendTimeRegEmailInput!
) {
  sendTimeRegEmail(input: $input) {
    clientMutationId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SendTimeRegEmailInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendTimeRegEmailPayload",
    "kind": "LinkedField",
    "name": "sendTimeRegEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sendTimeRegEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sendTimeRegEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "sendTimeRegEmailMutation",
    "operationKind": "mutation",
    "text": "mutation sendTimeRegEmailMutation(\n  $input: SendTimeRegEmailInput!\n) {\n  sendTimeRegEmail(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1b35bd489189cf5b35a638cf47fb6e18';

module.exports = node;
